export const VERSION = 'v1.5';
export const appName = 'Alobet88';
